// extracted by mini-css-extract-plugin
module.exports = {"dates":"dates-3q5ln"};